import PropTypes from 'prop-types'
import React from 'react'

import {
  Container,
  CardContainer,
  LogoSection,
  Logo,
} from './AuthLayout.styled'
// Theme-specific assets
import bgAuth from '../../assets/bgAuth.png'
import kindeDNLogo from '../../assets/kindeDNLogo.png'
import kindeMVLogo from '../../assets/kindeMVLogo.png'

function AuthLayoutView({ isDrayNow, children }) {
  // Just background and logo configuration
  const themeConfig = isDrayNow
    ? {
        logo: kindeDNLogo,
        logoAlt: 'DrayNow',
      }
    : {
        logo: kindeMVLogo,
        logoAlt: 'ModalView',
      }

  return (
    <Container style={{ backgroundImage: `url(${bgAuth})` }}>
      <CardContainer>
        <LogoSection>
          <Logo
            src={themeConfig.logo}
            alt={themeConfig.logoAlt}
            style={{ width: '120px', height: isDrayNow ? 'auto' : '34px' }}
          />
        </LogoSection>
        {children}
      </CardContainer>
    </Container>
  )
}

AuthLayoutView.propTypes = {
  isDrayNow: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
}

export { AuthLayoutView }
